/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commonloading1Inputs */



/**
* | output |
* | --- |
* | "Loading" |
*
* @param {Commonloading1Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const commonloading1 = /** @type {((inputs?: Commonloading1Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commonloading1Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Loading")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando")
	return /** @type {LocalizedString} */ ("Загрузка")
});
export { commonloading1 as "commonLoading" }